module.exports = __webpack_public_path__ + "fonts/AvenirLTW02-85Heavy.0bdae3d2de3ff2b27b6ff6dd640ee8dd.woff";